<script>
    import Vue from 'vue';
    
    //Based on https://jsfiddle.net/Herteby/ffe5rban/
    export default Vue.component('template-header', {
        props: {
            size: {
                type: Number,
                required: true,
                validate(value){
                    return value >= 1 && value <= 6;
                }
            }
        },
        render(renderer){
            const vm = this;
            
            return renderer(
                `h${vm.size}`, 
                vm.$slots.default
            );
        }
    });
</script>
